import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { useInitAuth } from '@lingaai/user-management';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { Layout } from './components/layout/Layout';
import { Login } from './pages/Login';
import { Signup } from './pages/Signup';
import { PendingApproval } from './pages/PendingApproval';
import { SetPassword } from './pages/auth/SetPassword';
import { Dashboard } from './pages/Dashboard';
import { Settings } from './pages/Settings';
import { FundDetails } from './pages/admin/FundDetails';
import { TenantList, TenantDetails } from './pages/super-admin';
import { BillingSuccess } from './pages/settings/BillingSuccess';
import { ThemeProvider } from './providers/ThemeProvider';

export default function App() {
  useInitAuth();

  return (
    <ThemeProvider>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/pending-approval" element={<PendingApproval />} />
          <Route path="/auth/set-password" element={<SetPassword />} />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Layout>
                  <Settings />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/settings/billing-success"
            element={
              <ProtectedRoute>
                <Layout>
                  <BillingSuccess />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/funds/:fundId"
            element={
              <ProtectedRoute>
                <Layout>
                  <FundDetails />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/super-admin/tenants"
            element={
              <ProtectedRoute>
                <Layout>
                  <TenantList />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/super-admin/tenants/:tenantId"
            element={
              <ProtectedRoute>
                <Layout>
                  <TenantDetails />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}
